export const prepareOrderUrl = '/order/prepare-payment/';